import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.progressElement = document.querySelector("#reading-progress");
    this.update();
  }

  update() {
    if (!this.progressElement) {
      return;
    }

    const contentHeight = document.documentElement.scrollHeight;
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const progress = scrollPosition / (contentHeight - windowHeight);

    this.progressElement.style.width = `${progress * 100}%`;
  }
}